import AddForm from "../../components/AddForm";
import { Form, Button, Row, Col } from 'react-bootstrap';
import UploadImage from "../../components/ImageUpload";
import { useState } from "react";
import { default as ReactSelect } from "react-select";
import axios from 'axios'
import {useSelector} from 'react-redux'
import { useEffect } from "react";
import {useLocation, useNavigate} from 'react-router-dom'
import PopUpModal from "../../components/PopupModal";
import { Alert } from "@mui/material";

const RegisterStore = () => {
    const loc = useLocation();
    const id = loc.state.id;
    const {user} = useSelector((state)=> state.auth);
    const userId = user.seller_profile_id;
    const userEmail = user.seller_profile_email;
    const [email, setEmail] = useState(userEmail);
    const [storeName, setStoreName] = useState();
    const [number, setNumber] = useState();
    const [alternativeNumber, setAlternativeNumber] = useState();
    const [address, setAddress] = useState();
    const [timings, setTimings] = useState();
    const [openingDays, setOpeningDays] = useState([]);
    const [location, setLocation] = useState();
    const [days, setDays] = useState([]);
    const [file, setFile] = useState(null);
    const [error, setError] = useState('');

    const getFile = (f)=> {
        setFile(f);
    }

    const [modal, setModal] = useState(false);
    const navigate = useNavigate();
    const Select = (props) => {
        return (
            <div>
                <Select {...props}>
                    <input
                        type=""
                        checked={props.isSelected}
                        onChange={() => null}
                    />{" "}
                    <label>{props.label}</label>
                </Select>
            </div>
        );
    };
    const daysOptions = [
        { value: "mon", label: "Mon" },
        { value: "tue", label: "Tue" },
        { value: "wed", label: "Wed" },
        { value: "thur", label: "Thu" },
        { value: "fri", label: "Fri" },
        { value: "sat", label: "Sat" },
        { value: "sun", label: "Sun" }
    ];
    const handleChange = (selected) => {
        const selectDays = selected.map((day) => day.value)
        setOpeningDays(selected);
        setDays(selectDays)
    }

    const opening_days = JSON.stringify(days);

    useEffect(()=> {
        navigator.geolocation.getCurrentPosition((props)=> {
            setLocation([props.coords.latitude,props.coords.longitude])
        })
    }, []);
    const shop_location = JSON.stringify(location);

    const handleSubmit = async(e)=> {
        e.preventDefault();
        const newStore = {
            seller_profile_id: userId,
            seller_type_id: id,
            seller_store_name: storeName,
            seller_store_address: address,
            seller_store_email: email,
            seller_store_number: number,
            seller_store_alternative_number: alternativeNumber,
            seller_store_tmings: timings,
            seller_store_days: opening_days,
            seller_store_map_location: shop_location
        }
        if (file) {
            const data = new FormData();
            const filename = Date.now() + file.name;
            data.append("name", filename);
            data.append("file", file);
            newStore.seller_store_logo = filename;
            try {
              await axios.post(process.env.REACT_APP_FIND_API_URL + "/upload", data, {withCredentials: true});
            } catch (error) {
              console.log(error);
            }
        }
        try {
            const res = await axios.post(process.env.REACT_APP_FIND_API_URL + `/store/register-store`, newStore);
            if(res.data) {
                setTimeout(()=> setModal(false), 1000);
                setTimeout(()=> navigate('/admin/dashboard'), 1000)
            }
        } catch (error) {
            setError(error)
        }
    }
    return (
        <>
            <AddForm title={'Register Store'} >
                {<PopUpModal title="Store Registered Successfully." show={modal} onHide={() => setModal(false)} />}
                {error && <Alert severity="error">{error}</Alert>}
                <Form onSubmit={handleSubmit}>
                    <Row className="mb-3">
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Store Name</Form.Label>
                                <Form.Control type="text" placeholder="Enter Store Name" value={storeName} onChange={(e) => setStoreName(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3" controlId="formBasicEmail">
                                <Form.Label>Email address</Form.Label>
                                <Form.Control type="email" placeholder="Enter email" value={email} onChange={(e) => setEmail(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md={12}>
                            <Form.Group className="mb-3">
                                <Form.Label>Address</Form.Label>
                                <Form.Control type="text" placeholder="Enter Address" value={address} onChange={(e) => setAddress(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Phone Number</Form.Label>
                                <Form.Control type="number" placeholder="Enter Phone Number" value={number} onChange={(e) => setNumber(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Alternative Phone Number</Form.Label>
                                <Form.Control type="number" placeholder="Enter Phone Number" value={alternativeNumber} onChange={(e) => setAlternativeNumber(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Opening Days</Form.Label>
                                <ReactSelect
                                            classNamePrefix='react-select-container'
                                            options={daysOptions}
                                            isMulti
                                            closeMenuOnSelect={false}
                                            hideSelectedOptions={false}
                                            components={{
                                                Select
                                            }}
                                            onChange={handleChange}
                                            allowSelectAll={true}
                                            value={openingDays}
                                        />
                            </Form.Group>
                        </Col>
                        <Col md="6">
                            <Form.Group className="mb-3">
                                <Form.Label>Opening Timings</Form.Label>
                                <Form.Control type="text" placeholder="e.g 9am-5pm" value={timings} onChange={(e) => setTimings(e.target.value)} />
                            </Form.Group>
                        </Col>
                        <Col md="12">
                            {
                                file &&
                                <img className='rounded' width="130px" height="130" alt="img" src={URL.createObjectURL(file)} />
                            }
                            <UploadImage title="logo" getFile={getFile} />
                        </Col>
                    </Row>
                    <div>
                        <Button variant="primary" type="submit" className="w-100">
                            Submit
                        </Button>
                    </div>
                </Form>
            </AddForm>
        </>
    );
}

export default RegisterStore;